import { vuexfireMutations } from 'vuexfire';
import users from './models/users';
import sprints from './models/sprints';
import stories from './models/stories';

export default {
  modules: {
    users,
    sprints,
    stories,
  },
  mutations: {
    ...vuexfireMutations,
  },
};
